<template>
  <div>
    <div v-if="itinerary && flight">
      <span>{{ itinerary.depdate }}</span>
    </div>
    <div
      :id="`itemexpander-${itinerary.jsonid}`"
      class="item-main pt-1 pb-1 flight-brick"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
    >
      <div class="item-title p-2 mx-2">
        <span v-if="!flightImg">{{ itinerary.jsontype.toUpperCase() }}</span>
        <div>
          <img
            v-if="itinerary.vendor"
            class="vendor-logo-img"
            :src="`https://www.trailfinders.com/graphics/flights/${itinerary.vendor}.gif`"
          >
        </div>
        <span class="ml-2">FLIGHT {{ itinerary.flightno.toUpperCase() }}</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop mr-2">
        <h6>{{ itinerary.cityfrom }} to {{ itinerary.cityto }}</h6>
        <p>with {{ itinerary.suppliername }}</p>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop mr-3">
        <h6>Departing {{ itinerary.deptime }}</h6>
        <p>
          Arriving {{ itinerary.arrtime }}
          <span
            v-if="itinerary.arrdate && itinerary.arrdate !== itinerary.depdate"
          >({{ itinerary.arrdate }})</span>
        </p>
        <div
          v-if="showCheckinLink()"
          class="pt-1 pb-1"
        >
          <a
            v-if="itinerary.vendorloc && bookingInfo.fil !== 'P'"
            :href="itinerary.checkininfo.link"
            target="_blank"
            class="flight-checkin-active-link mr-1"
          >Airline Ref:
          </a>
          {{ itinerary.vendorloc }}
        </div>

        <div v-else>
          <p
            v-if="
              itinerary.vendorloc && bookingInfo.fil !== 'P' && !friendFamily
            "
          >
            <span class="flight-checkin-active-link pr-1">Airline Ref:</span>
            <span class="flight-checkin-active-link-ref">{{
              itinerary.vendorloc
            }}</span>
          </p>
        </div>
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div
      v-if="itinerary.itinmsg"
      class="flights-itinerary-message"
    >
      {{ itinerary.itinmsg }}
    </div>
    <div
      v-if="dropdown"
      class="item-dropdown desktop-dropdown-flight"
    >
      <ul
        v-if="itinerary.status || itinerary.expanderItems.length > 0"
        style="margin-bottom: 0px"
      >
        <!-- Loop over all expanderItems -->

      </ul>
    </div>
    <div
      v-if="dropdown"
      class="item-dropdown flight-dropdown"
    >
      <!-- This will only be displayed on mobile devices -->
      <ul class="mobile-dropdown-flight">
        <li v-if="itinerary.cityfrom">
          <h4>Departing from</h4>
          <p>{{ itinerary.cityfrom }}</p>
        </li>
        <li v-if="itinerary.cityto">
          <h4>To</h4>
          <p>{{ itinerary.cityto }}</p>
        </li>
        <li v-if="itinerary.deptime">
          <h4>Departing at</h4>
          <p>{{ itinerary.deptime }}</p>
        </li>
        <li v-if="itinerary.arrtime">
          <h4>Arriving at</h4>
          <p>
            {{ itinerary.arrtime }}
            <span
              v-if="
                itinerary.arrdate && itinerary.arrdate !== itinerary.depdate
              "
            >({{ itinerary.arrdate }})</span>
          </p>
        </li>
        <li v-if="itinerary.suppliername">
          <p>
            with {{ itinerary.suppliername }} in {{ itinerary.baggageclass }}
          </p>
        </li>
        <li class="py-3">
          <a
            v-if="itinerary.vendorloc && bookingInfo.fil !== 'P'"
            :href="
              itinerary && itinerary.checkininfo && itinerary.checkininfo.link
                ? itinerary.checkininfo.link
                : ''
            "
            target="_blank"
          >Airline Ref:
          </a>
          {{ itinerary.vendorloc }}
        </li>
      </ul>
    </div>
    <div
      v-if="dropdown"
      class="mobile-dropdown-item mobile-dropdown-flight"
    >
      <ul>
        <li v-if="itinerary.status">
          <h4>Status</h4>
          <p>{{ itinerary.status }}</p>
        </li>
      </ul>
      <div
        v-if="itinerary.fnotes[0]"
        class="extra-info-notes"
      >
        Notes
        <ul style="border-top: 0px solid; padding-top: 0px; margin-top: 0px">
          <li
            v-for="(note, index) in itinerary.fnotes"
            :key="index"
          >
            <p style="padding-top: 12px">
              {{ note }}
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="!friendFamily && dropdown"
      class="flight-baggage"
    >
      <div
        v-if="
          itinerary.baggage !== '' &&
            baggage &&
            Object.keys(baggage).length !== 0
        "
      >
        <!--desktop baggage table-->
        <table class="desktop-baggage">
          <tr>
            <th
              v-if="bookingInfo.passenger_types.includes('adult')"
              colspan="2"
            >
              Per Adult
            </th>
            <th
              v-if="bookingInfo.passenger_types.includes('child')"
              colspan="2"
            >
              Per Child
            </th>
            <th
              v-if="bookingInfo.passenger_types.includes('infant')"
              colspan="2"
            >
              Per Infant
            </th>
            <th>
              Max Dimensions
            </th>
          </tr>
          <tr>
            <td v-if="bookingInfo.passenger_types.includes('adult')">
              No. of bags
            </td>
            <td v-if="bookingInfo.passenger_types.includes('adult')">
              Max weight
            </td>
            <td v-if="bookingInfo.passenger_types.includes('child')">
              No. of bags
            </td>
            <td v-if="bookingInfo.passenger_types.includes('child')">
              Max weight
            </td>
            <td v-if="bookingInfo.passenger_types.includes('infant')">
              No. of bags
            </td>
            <td v-if="bookingInfo.passenger_types.includes('infant')">
              Max weight
            </td>
            <td
              v-if="baggage.dims_general"
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims_general }}cm (total outside dimensions, length +
              width + height)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  baggage.dims.depth &&
                  baggage.dims.width &&
                  baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.depth }} length + {{ baggage.dims.width }} width +
              {{ baggage.dims.height }} height (total outside dimensions)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  !baggage.dims.depth &&
                  baggage.dims.width &&
                  baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.width }} width + {{ baggage.dims.height }} height
              (total outside dimensions)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  baggage.dims.depth &&
                  !baggage.dims.width &&
                  baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.depth }} length + {{ baggage.dims.height }} height
              (total outside dimensions)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  baggage.dims.depth &&
                  baggage.dims.width &&
                  !baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.depth }} length + {{ baggage.dims.width }} width +
              (total outside dimensions)
            </td>
            <td
              v-if="!baggage.dims_general && !baggage.dims"
              colspan="2"
              rowspan="2"
            >
              No dimension information provided
            </td>
          </tr>
          <tr>
            <td v-if="bookingInfo.passenger_types.includes('adult')">
              {{ baggage.pieces ? convertPiece(baggage.pieces) : "" }}
            </td>
            <td v-if="bookingInfo.passenger_types.includes('adult')">
              {{ baggage.weight ? `${baggage.weight}g` : "" }}
            </td>
            <td v-if="bookingInfo.passenger_types.includes('child')">
              {{ baggage.pieceschild ? convertPiece(baggage.pieceschild) : "" }}
            </td>
            <td v-if="bookingInfo.passenger_types.includes('child')">
              {{ baggage.weightchild ? `${baggage.weightchild}g` : "" }}
            </td>
            <td v-if="bookingInfo.passenger_types.includes('infant')">
              {{
                baggage.piecesinfant ? convertPiece(baggage.piecesinfant) : ""
              }}
            </td>
            <td v-if="bookingInfo.passenger_types.includes('infant')">
              {{ baggage.weightinfant ? `${baggage.weightinfant}g` : "" }}
            </td>
          </tr>
          <tr v-if="baggage.description ">
            <th
              colspan="8"
            >
              Notes
            </th>
          </tr>
          <tr v-if="baggage.description ">
            <td
              class="baggage-desc"
              colspan="8"
              v-html="baggage.description"
            ></td>
          </tr>
        </table>

        <!--mobile baggage table-->

        <table class="mobile-baggage">
          <tr v-if="bookingInfo.passenger_types.includes('adult')">
            <th colspan="2">
              Per Adult
            </th>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('adult')">
            <td>No. of bags</td>
            <td>Max weight</td>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('adult')">
            <td>
              {{ baggage.pieces ? convertPiece(baggage.pieces) : "" }}
            </td>
            <td>
              {{ baggage.weight ? `${baggage.weight}g` : "" }}
            </td>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('child')">
            <th colspan="2">
              Per Child
            </th>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('child')">
            <td>No. of bags</td>
            <td>Max weight</td>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('child')">
            <td>
              {{ baggage.pieceschild ? convertPiece(baggage.pieceschild) : "" }}
            </td>
            <td>
              {{ baggage.weightchild ? `${baggage.weightchild}g` : "" }}
            </td>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('infant')">
            <th colspan="2">
              Per Infant
            </th>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('infant')">
            <td>No. of bags</td>
            <td>Max weight</td>
          </tr>
          <tr v-if="bookingInfo.passenger_types.includes('infant')">
            <td>
              {{
                baggage.piecesinfant ? convertPiece(baggage.piecesinfant) : ""
              }}
            </td>
            <td>
              {{ baggage.weightinfant ? `${baggage.weightinfant}g` : "" }}
            </td>
          </tr>
          <tr>
            <th colspan="2">
              Max dimensions
            </th>
          </tr>
          <tr>
            <td
              v-if="baggage.dims_general"
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims_general }}cm (total outside dimensions, length +
              width + height)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  baggage.dims.depth &&
                  baggage.dims.width &&
                  baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.depth }} length + {{ baggage.dims.width }} width +
              {{ baggage.dims.height }} height (total outside dimensions)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  !baggage.dims.depth &&
                  baggage.dims.width &&
                  baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.width }} width + {{ baggage.dims.height }} height
              (total outside dimensions)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  baggage.dims.depth &&
                  !baggage.dims.width &&
                  baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.depth }} length + {{ baggage.dims.height }} height
              (total outside dimensions)
            </td>
            <td
              v-if="
                !baggage.dims_general &&
                  baggage.dims &&
                  baggage.dims.depth &&
                  baggage.dims.width &&
                  !baggage.dims.height
              "
              colspan="2"
              rowspan="2"
            >
              Up to
              {{ baggage.dims.depth }} length + {{ baggage.dims.width }} width +
              (total outside dimensions)
            </td>
            <td
              v-if="!baggage.dims_general && !baggage.dims"
              colspan="2"
              rowspan="2"
            >
              No dimension information provided
            </td>
          </tr>
        </table>
        <table
          v-if="baggage.description"
          class="mobile-baggage"
        >
          <tr>
            <th>Notes</th>
          </tr>
          <tr>
            <td
              class="baggage-desc-mobile"
              v-html="baggage.description"
              
            ></td>
          </tr>
        </table>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { convertPiece, pieceLabel, convertBaggage } from "../baggage.module";
import dayjs from '@/lib/dayjs';
export default {
  props: {
    flight: {
      type: Object,
      default: null,
    },
    flightNo: {
      type: String,
      default: null,
    },
    itinerary: {
      type: Object,
      default: null,
    },
    baggage: {
      type: Object,
      default: null,
    },
    dropdownProp: {
      type: Boolean,
      default: false,
    },
    expandAllProp: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      section: "adult",
      baggageID: "",
      dropdown: false,
      checkinDropdown: false,
      flightImg: "https://www.trailfinders.com/graphics/flights/VS.gif",
      sqlSeating: {},
      sqlAirlineInfo: {},
      activeAlerts: [],
      appInstall: false,
      source: "EXT",
      fil: "M",
      country: "UK",
      showAppInstallExt: false,
      showAppInstallInt: false,
      show: "UK",
      referer: "com",
    };
  },
  computed: {
    ...mapGetters({
      bookingInfo: "booking/getBookingInfo",
      friendFamily: "friendFamily/isFriendFamily",
    }),
  },
  watch: {
    expandAllProp(newVal) {
      if (newVal === true) {
        this.dropdown = true;
      } else {
        this.dropdown = false;
      }
      return newVal;
    },
  },
  mounted() {
    this.dropdown = this.dropdownProp;
  },
  methods: {
    showSection(key) {
      this.section = key;
    },
    convertPiece: convertPiece,
    convertBaggage: convertBaggage,
    pieceLabel: pieceLabel,
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    showCheckinLink() {
      if (this.itinerary.checkininfo && this.itinerary.checkininfo.link) {
        // Set departure time
        const _departDate = dayjs(
          new Date(`${this.itinerary.depdate} ${this.itinerary.deptime}`)
        );
        // Set checkin time
        const _checkinTime = dayjs(
          new Date(`${this.itinerary.depdate} ${this.itinerary.deptime}`)
        ).subtract(this.itinerary.checkininfo.time, "hours");
        // Set today
        let _today = dayjs();
        // Get difference in hours between today and departure time
        const duration = dayjs.duration(_today.diff(_departDate));
        const hours = duration.asHours();
        if (_departDate >= _today && _checkinTime <= _today) {
          return true;
        } else if (_departDate <= _today.add(24, "hours") && hours < 24) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style>
@import "./styles.scss";
</style>
